// FILE: src/pages/ManagerWelcome.jsx
// Simple holding page for manager-only users until grants activate,
// with a banner and CTA to Plans for their own business account.
import React from "react";
import { useAccess } from "../access/AccessContext";

export default function ManagerWelcome({ user, onUpgrade }) {
  const { managedOwners } = useAccess();
  const hasActiveGrants = Array.isArray(managedOwners) && managedOwners.length > 0;

  const goPlans = () => {
    if (typeof onUpgrade === "function") onUpgrade();
    else window.location.assign("/plans");
  };

  return (
    <div className="container" style={{ maxWidth: 760, margin: "24px auto", textAlign: "left", padding: "0 16px" }}>
      <div
        role="status"
        aria-live="polite"
        className="banner"
        style={{
          background: "#fff7ed",
          border: "1px solid #fed7aa",
          color: "#7c2d12",
          borderRadius: 12,
          padding: "12px 14px",
          marginBottom: 12,
          boxShadow: "0 1px 6px rgba(0,0,0,.04)",
        }}
      >
        <strong>Read-only business access unlocks after verification.</strong>{" "}
        You’ll get access once an administrator confirms the account owner is deceased.
      </div>

      <div className="card" style={{ padding: 20, background: "#fff", borderRadius: 12, boxShadow: "0 2px 12px rgba(0,0,0,.06)" }}>
        <h2 style={{ marginTop: 0 }}>Welcome, Business Account Manager</h2>

        {!hasActiveGrants ? (
          <p>
            You’ve been added as a <b>Business Account Manager</b>. For privacy, no information is visible yet.
            Once verification is complete, a mode selector will appear so you can view the business account in <b>read-only</b>.
          </p>
        ) : (
          <p>
            You have active <b>business</b> manager access. Use the account switcher at the top to view the managed business account in read-only mode.
          </p>
        )}

        <hr style={{ margin: "16px 0" }} />

        <h3>Want your own business account?</h3>
        <p>
          To set up your own <b>business</b> LastWish Box account, you’ll need a subscription. Business manager access is separate and remains free/read-only.
        </p>
        <button className="btn btn-main" onClick={goPlans}>See Plans</button>
      </div>

      <style>{`
        .btn{border:none;border-radius:10px;font-weight:700;cursor:pointer;padding:10px 18px}
        .btn-main{background:#f15822;color:#fff}
      `}</style>
    </div>
  );
}
